export default __webpack_public_path__ + "media/images/images/jvqmap/marker/grey-1de8c2b21267fa4581f6998ad9cd0ced.png";